import { createContext } from 'react';
import type { CurrentUserType } from 'sharedTypes/user/userTypes';

export const CurrentUserDefault: CurrentUserType = {
  OktaId: '',
  FullName: ' ',
  FirstName: ' ',
  LastName: ' ',
  EmailAddress: '',
  IsCompliant: false,
  IsHazmatCertified: false,
  HasAutoTracking: false,
  CarrierName: '',
  CarrierCode: '',
  CargoInsExpirationDate: '',
  LiabilityInsExpirationDate: '',
  CargoInsRenewalEffectiveDate: null,
  LiabilityInsRenewalEffectiveDate: null,
  LoadTrackingVendorId: null,
  UseMP: false,
  HasReeferIns: false,
  UnitCount: null as number,
  IsHighRiskCertified: false
}

export const UserContext = createContext(CurrentUserDefault);
UserContext.displayName = 'UserContext';

export const LoadDetailStatusContext = createContext(true);
LoadDetailStatusContext.displayName = 'LoadDetailStatusContext';

export const PickupFilterContext = createContext(null);
PickupFilterContext.displayName = 'PickupFilterContext';

export const PickupDateContext = createContext(null);
PickupDateContext.displayName = 'PickupDateContext';
